import React from "react";
import styled from "@emotion/styled";

const ImageContainer = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 0px 0px 0px 25px;
  background-color: rgba(57, 200, 118, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 350px) {
    display: none;
  }
`;

const Image = styled.img`
  filter: drop-shadow(rgba(57, 200, 118, 0.5) 0px 10px 10px);
`;

const SellReceiptImage = ({ src }) => (
  <ImageContainer className="receipt-print-image">
    <Image src={src} alt="" />
  </ImageContainer>
);

export default SellReceiptImage;
